import { apiSlice } from "../app/api/apiSlice";

export const CategoriesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPaginatedUserCategories: builder.query({
            query: ({user_id, paginate, page}) => (page == "")? `/user/user-categories/${user_id}/${paginate}` : `user/user-categories/${user_id}/${paginate}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Categories']
        }),
        getCategoriesPageChange: builder.mutation({
            query: ({user_id, paginate, page}) => `user/user-categories/${user_id}/${paginate}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Categories']
        }),
        getUserCategoriesForRoutes: builder.query({
            query: ({user_id}) => `/user/categories/${user_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Categories']
        }),
        createCategory: builder.mutation({
            query: (input) => ({
                url: `user/create-category`,
                method: 'POST',
                body: { ...input }
            }),
            invalidatesTags: ['Categories']
        }),
        editCategory: builder.mutation({
            query: (input) => ({
                url: `user/edit-category/${input.id}`,
                method: 'PUT',
                body: { ...input }
            }),
            invalidatesTags: ['Categories']
        }),
        getCategoryById: builder.query({
            query: (id) => `/user/category/${id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['Categories']
        }),
        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `user/delete-category/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Categories']
        }),
    })
})

export const {
    useCreateCategoryMutation,
    useEditCategoryMutation,
    useGetPaginatedUserCategoriesQuery,
    useGetCategoriesPageChangeMutation,
    useGetCategoryByIdQuery,
    useDeleteCategoryMutation,
    useGetUserCategoriesForRoutesQuery,
} = CategoriesApiSlice

